import { useEffect, useRef, useState } from "react";
import RecordRTC, { invokeSaveAsDialog, MediaStreamRecorder } from "recordrtc";
import {
  deviceListState,
  isRecordingState,
  isStreamingState,
  isUploadingState,
  isVideoState,
  micState,
  practiceVideoSrcState,
  recorderState,
  selectedDeviceState,
  streamState,
  volumeState,
} from "../../recoil/record";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useApplyActions from "./apply";
import { applyStepState } from "../../recoil/pageStep";
import { authState } from "../../recoil/auth";
import { Buffer } from "buffer";
import { Decoder, Encoder, tools, Reader } from "ts-ebml";
import useApiActions from "../../recoil/api";
import { useNavigate } from "react-router-dom";

const useRecord = () => {
  window.Buffer = Buffer;

  const volumeIntervalRef = useRef(null);
  const applyActions = useApplyActions();
  const auth = useRecoilValue(authState);

  //영상 송출 state
  const [stream, setStream] = useRecoilState(streamState);

  //영상 저장시 필요한 state
  const [recorder, setRecorder] = useRecoilState(recorderState);

  //녹화중인지 표시 state
  const [isRecording, setIsRecording] = useRecoilState(isRecordingState);

  //파일 저장 완료 되었는지 표시
  const setIsUploading = useSetRecoilState(isUploadingState);

  //streaming 표시
  const [isStreaming, setIsStreaming] = useRecoilState(isStreamingState);

  //volume
  const [volume, setVolume] = useRecoilState(volumeState);

  const [deviceList, setDeviceList] = useRecoilState(deviceListState);
  //연습 url
  const setPracticeVideoSrc = useSetRecoilState(practiceVideoSrcState);
  //선택 장비 state
  const [selectedDevice, setSelectedDevice] =
    useRecoilState(selectedDeviceState);

  const [isVideo, setIsVideo] = useRecoilState(isVideoState);
  const setApplyStep = useSetRecoilState(applyStepState);
  const setHasPermissions = useSetRecoilState(micState);
  const { setLog } = useApiActions();
  const navigate = useNavigate();

  // useEffect(() => {
  //   gotDevices();
  //   navigator.permissions
  //     .query({
  //       name: "microphone",
  //     })
  //     .then((result) => {
  //       console.log(result)
  //       if (result.state === "prompt") {
  //         navigator.mediaDevices
  //           .getUserMedia({audio: true})
  //           .then((stream) => {
  //             setHasPermissions({state: "granted"});
  //             stream.getTracks().forEach((track) => track.stop());
  //             gotDevices();
  //           })
  //           .catch((err) => {
  //             console.error(err);
  //             setHasPermissions({state: "denied"});
  //           })
  //       } else {
  //         setHasPermissions(result);
  //         gotDevices();
  //       }
  //       result.onchange = () => {
  //         setHasPermissions(result);
  //         gotDevices();

  //         setTimeout(() => {
  //           gotDevices();
  //         }, 2000);
  //       };
  //     });

  //   navigator.mediaDevices.ondevicechange = () => {
  //     gotDevices();
  //   };
  // }, []);

  useEffect(() => {
    gotDevices();
    
    const checkMicPermission = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({audio: true})
        if (stream) {
          setHasPermissions({state: "granted"})
          stream.getTracks().forEach((track) => track.stop());
          gotDevices();
        }
      } catch (err) {
        console.error(err);
        setHasPermissions({state: "denied"})
      }
    }

    checkMicPermission();
  }, []);

  return {
    changeDevice,
    isDeviceReady,
    getStream,
    stopStreaming,
    handleRecording,
    stopRecording,
    gotPermissions,
    handleStreaming,
    gotDevices,
    forceStopRecording,
  };

  async function changeDevice(type, deviceId) {
    const devices = {
      ...selectedDevice,
      [type]: {
        deviceId,
      },
    };
    setSelectedDevice(devices);
    // console.log("changeDevice :", devices);
    setIsStreaming(false);
  }

  async function isDeviceReady() {
    if (stream && recorder) {
      return true;
    }

    return false;
  }

  async function getStream() {
    if (stream) {
      return [stream, recorder];
    } else {
      const [_stream, _recorder] = await handleStreaming();
      setStream(_stream);
      setRecorder(_recorder);
      return _stream;
    }
  }

  async function stopStreaming() {
    clearInterval(volumeIntervalRef.current);
    setIsStreaming(false);

    if (stream) {
      stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }

  async function handleStreaming(selectedDevice = selectedDevice) {
    try {
      const _stream = await navigator.mediaDevices.getUserMedia(selectedDevice);
      
      const audioContext = new AudioContext();
      const mediaStreamAudioSourceNode =
        audioContext.createMediaStreamSource(_stream);
      const analyserNode = audioContext.createAnalyser();
      mediaStreamAudioSourceNode.connect(analyserNode);
      const pcmData = new Float32Array(analyserNode.fftSize);

      const onFrame = () => {
        analyserNode.getFloatTimeDomainData(pcmData);
        let sumSquares = 0.0;
        for (const amplitude of pcmData) {
          sumSquares += amplitude * amplitude;
        }
        setVolume(sumSquares / pcmData.length);
        // console.log("on frame handled");
      };
      clearInterval(volumeIntervalRef.current);
      volumeIntervalRef.current = setInterval(() => {
        onFrame();
      }, 100);

      if (selectedDevice.video) {
        setIsVideo(1);
      } else {
        setIsVideo(2);
      }

      // console.log("alwkenlkaweklanwklnkl :", isVideo);

      const _recorder = new RecordRTC(_stream, {
        type: "video",
        recorderType: MediaStreamRecorder,
        // mimeType: "video/webm;codecs=vp8",
        mimeType: "video/mp4",
        timeSlice: 1000,
        ondataavailable: function (blob) {
          if (blob.size < 0) {
            alert("파일이 올바르지 않습니다.");
          }
        },
        onTimeStamp: function (timestamp) {},

        canvas: {
          width: 640,
          height: 480,
        },
      });

      setIsStreaming(true);
      setStream(_stream);
      setRecorder(_recorder);
      // console.log(_stream, _recorder);

      return [_stream, _recorder];
    } catch (error) {
      console.error("Error accessing media devices: ", error);

      // window.location.href = "/";
      setApplyStep((old) => 0)

      alert("입력장치를 찾을 수 없습니다. 메인페이지로 돌아갑니다.")
    }
  }

  async function handleRecording() {
    if (await isDeviceReady()) {
      recorder.startRecording();
    }
  }

  async function forceStopRecording() {
    recorder.stopRecording();
  }

  async function stopRecording(params) {
    if (params.isPractice) {
      return await recorder.stopRecording(async () => {
        setIsUploading(true);

        const blob = await recorder.getBlob();
        setPracticeVideoSrc(URL.createObjectURL(blob));
        setIsUploading(false);
      });
    }

    return await recorder.stopRecording(async () => {
      setIsUploading(true);

      const blob = await recorder.getBlob();

      const fileRes = await applyActions.uploadUserRecordFile({
        file: new File([blob], "blob.mp4", { type: "video/mp4" }),
        user_sn: auth.user.payload.user_sn,
        examNumber: params.examNumber,
      });

      // 인터넷이 끊긴 상황에서 제출했을 때
      if (fileRes === undefined) {
        alert("문제 제출 실패(1).\n인터넷 연결상태를 확인해주세요.");
        navigate("/");
      }
      // 동영상 전송 중 인터넷이 끊겼을 때
      if (fileRes?.status === 400) {
        alert("문제 제출 실패(2).\n인터넷 연결상태를 확인해주세요.");
        navigate("/");
      }
      // 인터넷 문제로 추정
      if (fileRes?.status === 500) {
        alert("문제 제출 실패(3).\n인터넷 연결상태를 확인해주세요.");
        navigate("/");
      }

      if (fileRes?.status === 200) {
        const res = await applyActions.applySubmit({
          url: fileRes.data,
          examNumber: params.examNumber,
          media_type: params.media_type,
          user_sn: auth.user.payload.user_sn,
        });

        setTimeout(() => {
          if (res?.status === 200) {
            setIsUploading(false);
          } else {
            alert(
              `${params.examNumber}문항 업로드에 실패했습니다. ${params.examNumber} 문항을 재응시합니다.`
            );
            window.location.reload();
          }
        }, 2000);
      }

      return fileRes;
    });
  }

  function gotDevices() {
    navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
      // console.log("deviceInfos :", deviceInfos);
      let device_list = [];

      for (let i = 0; i < deviceInfos.length; i++) {
        if (deviceInfos[i].deviceId.toLowerCase() !== "default") {
          device_list.push(deviceInfos[i]);
        }
      }

      // console.log("recoder js device_list :", device_list);

      // setDeviceList(deviceInfos);
      setDeviceList(device_list);
    });
  }

  function gotPermissions() {}

  async function injectMetadata(blob) {
    const decoder = new Decoder();
    const reader = new Reader();
    reader.logging = false;
    reader.drop_default_duration = false;

    return readAsArrayBuffer(blob).then((buffer) => {
      const elms = decoder.decode(buffer);
      elms.forEach((elm) => {
        reader.read(elm);
      });
      reader.stop();

      const refinedMetadataBuf = tools.makeMetadataSeekable(
        reader.metadatas,
        reader.duration,
        reader.cues
      );
      const body = buffer.slice(reader.metadataSize);

      return new Blob([refinedMetadataBuf, body], { type: blob.type });
    });
  }

  function readAsArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (ev) => {
        reject(ev.error);
      };
    });
  }
};

export default useRecord;
